import React from 'react';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { useDispatch, useSelector } from 'react-redux';
import StyledText from 'src/common/refactoredComponents/styledText/StyledText';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import { useTranslation } from 'react-i18next';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import { updateCartDataShipping } from 'src/pages/scheduleSurgery/redux/actions';
import moment from 'moment/moment';
import { avoidDeploymentType, isMobileView, isTransferSurgery} from 'src/utils/util';
import { sizes } from 'src/styles/Media.styled';
import { DARK_GRAY_FONT_COLOR, DARK_NAVY_FONT_COLOR, FONT_FAMILY_DEMI, SEMANTIC_TEXT_SMALL_PX, SMALL_TEXT_PX } from 'src/styles/fonts/MCFontConstants';

const NtCheckboxCheckedAndDisabled = ({
    productKey,
    label,
    batchLocations,
    nonTissueProduct,
    isShowCheckBox = false,
    isMessageDisplay = false,
    isShowLabelEmpty = false,
    isShowSetLocation = true,
}) => {

    const surgeryDate = useSelector(
        (state) => state.surgeryReducer.surgeryDetails.surgeryDateTime
    );
    const DateSelected = moment(surgeryDate).utc().format('YYYY-MM-DD');
    const TodayDate = new Date();
    const currentDate = moment(TodayDate).utc().format('YYYY-MM-DD');
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const batchAllocationWithParked = batchLocations?.batchAllocations?.filter(
        (batch) => (avoidDeploymentType(countryISOCode) ? true : batch.isParked)
    );
    const shipDontShipSurgery = useSelector(
        (state) => state.loginReducer.shipDontShipSurgery
    );
    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );

    const { t } = useTranslation();
    const dispatch = useDispatch();
    useEffectWithErrorLogging(() => {
        dispatch(
            updateCartDataShipping(
                { shippingRequirement: false, transferComplete: true },
                [productKey]
            )
        );
    }, [batchLocations]);
    let validBatch = batchLocations?.batchAllocations
        ?.filter((batch) =>
            avoidDeploymentType(countryISOCode) ? true : batch.isParked
        )
        .find((batch) => batch.id === nonTissueProduct?.batchAllocation?.id);

    return (
        <>
            {shipDontShipSurgery !== 'NOT_VISIBLE' && isShowCheckBox && (
                <Checkbox 
                    checked={
                        batchAllocationWithParked != undefined &&
                        batchAllocationWithParked.length > 0
                            ? DateSelected <= currentDate
                                ? true
                                : avoidDeploymentType(countryISOCode)
                                ? true
                                : batchAllocationWithParked[0]?.isParked
                            : true
                    }
                    label={
                        isShowLabelEmpty
                            ? ''
                            : t(
                                  'scheduleSurgery.Shipping.ProductCard.DontShipSet'
                              )
                    }
                    disabled={
                        batchAllocationWithParked != undefined &&
                        batchAllocationWithParked.length > 0
                            ? DateSelected <= currentDate
                                ? true
                                : avoidDeploymentType(countryISOCode)
                                ? true
                                : batchAllocationWithParked[0]?.isParked
                            : true
                    }
                    margin={isCondensedView && !isTransferSurgery() ? '0 -4px 0px 5px' : !isCondensedView && isTransferSurgery() ? '0 6px 0 0' : '0 -4px 0 5px'}
                    id='surgery-shipping-Nt-CheckboxCheckedAndDisabled'
                    labelStyleObj={{
                        fontSize: SEMANTIC_TEXT_SMALL_PX,
                        fontFamily: FONT_FAMILY_DEMI,
                        color: DARK_NAVY_FONT_COLOR,
                    }}
                    background={'none'}
                    checkboxBorder={'1.5px solid #555555'}
                    alignItemDirection={'center'}
                    hoverEffect={'false'}
                    disableFocusEffect={'true'}
                />
            )}
            {isMessageDisplay && (
                <>
                    {isShowSetLocation && (
                        <StyledText
                            fontColor={DARK_GRAY_FONT_COLOR}
                            fontSize={SMALL_TEXT_PX}
                            fontFamily={FONT_FAMILY_DEMI}
                            margin="12px 0px 0px 0px"
                        >
                            {t(
                                'scheduleSurgery.Shipping.ProductCard.SetLocation'
                            )}
                        </StyledText>
                    )}
                    <CustomLabel
                        fSize={
                            isCondensedView
                                ? '13px!important'
                                : '14px!important'
                        }
                        color={
                            isCondensedView
                                ? label && !validBatch
                                    ? batchAllocationWithParked != undefined &&
                                      batchAllocationWithParked.length > 0
                                        ? DateSelected <= currentDate
                                            ? (
                                                  avoidDeploymentType(
                                                      countryISOCode
                                                  )
                                                      ? true
                                                      : batchAllocationWithParked[0]
                                                            ?.isParked
                                              )
                                                ? '#087b11'
                                                : '#087b11'
                                            : (
                                                  avoidDeploymentType(
                                                      countryISOCode
                                                  )
                                                      ? true
                                                      : batchAllocationWithParked[0]
                                                            ?.isParked
                                              )
                                            ? '#087b11'
                                            : '#A3001E'
                                        : '#087b11'
                                    : batchAllocationWithParked != undefined &&
                                      batchAllocationWithParked.length > 0
                                    ? DateSelected <= currentDate
                                        ? (
                                              avoidDeploymentType(
                                                  countryISOCode
                                              )
                                                  ? true
                                                  : batchAllocationWithParked[0]
                                                        ?.isParked
                                          )
                                            ? '#087b11'
                                            : '#087b11'
                                        : (
                                              avoidDeploymentType(
                                                  countryISOCode
                                              )
                                                  ? true
                                                  : batchAllocationWithParked[0]
                                                        ?.isParked
                                          )
                                        ? '#087b11'
                                        : '#A3001E'
                                    : '#087b11'
                                : '#087b11'
                        }
                        spanIcon={
                            isCondensedView
                                ? label && !validBatch
                                    ? batchAllocationWithParked != undefined &&
                                      batchAllocationWithParked.length > 0
                                        ? DateSelected <= currentDate
                                            ? (
                                                  avoidDeploymentType(
                                                      countryISOCode
                                                  )
                                                      ? true
                                                      : batchAllocationWithParked[0]
                                                            ?.isParked
                                              )
                                                ? false
                                                : false
                                            : (
                                                  avoidDeploymentType(
                                                      countryISOCode
                                                  )
                                                      ? true
                                                      : batchAllocationWithParked[0]
                                                            ?.isParked
                                              )
                                            ? false
                                            : true
                                        : false
                                    : batchAllocationWithParked != undefined &&
                                      batchAllocationWithParked.length > 0
                                    ? DateSelected <= currentDate
                                        ? (
                                              avoidDeploymentType(
                                                  countryISOCode
                                              )
                                                  ? true
                                                  : batchAllocationWithParked[0]
                                                        ?.isParked
                                          )
                                            ? false
                                            : false
                                        : (
                                              avoidDeploymentType(
                                                  countryISOCode
                                              )
                                                  ? true
                                                  : batchAllocationWithParked[0]
                                                        ?.isParked
                                          )
                                        ? false
                                        : true
                                    : false
                                : false
                        }
                        marginLeft={window.innerWidth <= sizes.mobileDevice && isTransferSurgery() && isCondensedView ? '11px': ''}
                        label={
                            label && !validBatch
                                ? batchAllocationWithParked != undefined &&
                                  batchAllocationWithParked.length > 0
                                    ? DateSelected <= currentDate
                                        ? (
                                              avoidDeploymentType(
                                                  countryISOCode
                                              )
                                                  ? true
                                                  : batchAllocationWithParked[0]
                                                        ?.isParked
                                          )
                                            ? t(
                                                  'scheduleSurgery.Shipping.ProductCard.TransferComplete'
                                              )
                                            : t(
                                                  'scheduleSurgery.Shipping.ProductCard.TransferComplete'
                                              )
                                        : (
                                              avoidDeploymentType(
                                                  countryISOCode
                                              )
                                                  ? true
                                                  : batchAllocationWithParked[0]
                                                        ?.isParked
                                          )
                                        ? t(
                                              'scheduleSurgery.Shipping.ProductCard.TransferComplete'
                                          )
                                        : t(
                                              'scheduleSurgery.Shipping.ProductCard.transferMessage'
                                          )
                                    : t(
                                          'scheduleSurgery.Shipping.ProductCard.TransferComplete'
                                      )
                                : batchAllocationWithParked != undefined &&
                                  batchAllocationWithParked.length > 0
                                ? DateSelected <= currentDate
                                    ? (
                                          avoidDeploymentType(countryISOCode)
                                              ? true
                                              : batchAllocationWithParked[0]
                                                    ?.isParked
                                      )
                                        ? t(
                                              'scheduleSurgery.Shipping.ProductCard.TransferComplete'
                                          ) +
                                          ' ' +
                                          (nonTissueProduct?.batchAllocation?.id?.trim()
                                              ? `: ${t(
                                                    'scheduleSurgery.Shipping.BatchLocationCard.batchLabel'
                                                )} ` +
                                                ' ' +
                                                nonTissueProduct
                                                    ?.batchAllocation?.id
                                              : '')
                                        : t(
                                              'scheduleSurgery.Shipping.ProductCard.TransferComplete'
                                          )
                                    : (
                                          avoidDeploymentType(countryISOCode)
                                              ? true
                                              : batchAllocationWithParked[0]
                                                    ?.isParked
                                      )
                                    ? t(
                                          'scheduleSurgery.Shipping.ProductCard.TransferComplete'
                                      ) +
                                      ' ' +
                                      (nonTissueProduct?.batchAllocation?.id?.trim()
                                          ? t(
                                                'scheduleSurgery.Shipping.BatchLocationCard.batchLabel'
                                            ) +
                                            ' ' +
                                            nonTissueProduct?.batchAllocation
                                                ?.id
                                          : '')
                                    : t(
                                          'scheduleSurgery.Shipping.ProductCard.TransferFailed'
                                      ) +
                                      ' ' +
                                      (nonTissueProduct?.batchAllocation?.id?.trim()
                                          ? t(
                                                'scheduleSurgery.Shipping.BatchLocationCard.batchLabel'
                                            ) +
                                            ' ' +
                                            nonTissueProduct?.batchAllocation
                                                ?.id
                                          : '') +
                                      t(
                                          'scheduleSurgery.Shipping.NonTissuecomponents.msg'
                                      )
                                : t(
                                      'scheduleSurgery.Shipping.ProductCard.TransferComplete'
                                  )
                        }
                        textAlign={'left'}
                    />
                </>
            )}
        </>
    );
};

export default NtCheckboxCheckedAndDisabled;
